export Pagination from './src/js/Pagination';
export PaginationContainer from './src/js/PaginationContainer';



// WEBPACK FOOTER //
// ./index.js